/**
 * Which address actually reaches a machine.
 *
 * Hardened machines deny all inbound from the internet, so their public `ip`
 * is unreachable even though it is still set — it remains the machine's egress
 * source, which the gpu-watchdog webhook matches on. The tailnet address is
 * the way in.
 *
 * Every place that shows an address to SSH to, or builds an `ssh` string,
 * should go through this rather than reading `ip` directly. Mirrors
 * `SSHTarget.from_machine` on the backend.
 */
export interface HostAddressable {
  ip?: string | null;
  tailscale_ip?: string | null;
}

/** The reachable address, preferring the tailnet. Null when neither is known. */
export function machineHost(machine: HostAddressable): string | null {
  return machine.tailscale_ip ?? machine.ip ?? null;
}

/** True when the address returned by {@link machineHost} is a tailnet address. */
export function isTailnetHost(machine: HostAddressable): boolean {
  return Boolean(machine.tailscale_ip);
}
